import React, { useCallback, useMemo, useRef } from "react";
import { isBrowser } from "../isBrowser";

export const useMouseLongPress = <T extends () => void>(callback: T) => {
  const timer = useRef(0);
  const handler = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      if (!isBrowser) return;
      if (event.type === "mousedown") {
        timer.current = window.setInterval(() => {
          callback();
        }, 100);
      } else {
        window.clearInterval(timer.current);
      }
    },
    [callback],
  );
  const handlers = useMemo(
    () => ({
      onMouseDown: handler,
      onMouseOut: handler,
      onMouseUp: handler,
      onClick: callback,
    }),
    [callback, handler],
  );
  return handlers;
};
